<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t("alterar-obrigatoriedade") }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <div class="columns is-flex-wrap">
            <div class="column is-6">
                <vss-select
                    title="obrigatorio"
                    :value="obrigatorioSelected"
                    :options="obrigatorioSelect"
                    :loading="isLoading"
                    @input="updateValueObrigatorio"
                    mlLabels
                />
            </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import FormFormularioService from '@/services/AssMotivoAtendimentoFormFormularioService';

// MENSAGENS
import Message from "@/models/Message";

export default {
    props: {
        selected: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            service: new FormFormularioService(this.$http, this.$router),
            assMotivoAtendimentoFormulario: {},
            isLoading: false,
            obrigatorioSelect: [
                { id: 0, label: "nao" },
                { id: 1, label: "sim" },
            ],
            obrigatorioSelected: {},
            contexto: '',
            msgs: [],
        }
    },
    created() {
        this.contexto = this.$route.meta.contexto.slice(0, 3);
        if (this.selected && this.selected.id) this.carregarDados();
    },
    methods: {
        carregarDados() {
            this.isLoading = true;

            this.service.find (
                this.selected.id,
                this.contexto
            )
            .then(this.mapItem)
            .then(value => {
                this.assMotivoAtendimentoFormulario = value;
                this.obrigatorioSelected = 
                    this.obrigatorioSelect.filter((item) => item.id == this.assMotivoAtendimentoFormulario.obrigatorio)[0];
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar o formulário.');
            })
            .finally(_ => {
                this.isLoading = false;
            });
        },
        mapItem (body) {
            const form = body.content;
            return {
                id: form.id,
                uuid_form_formulario: form.uuid_form_formulario,
                id_tabela_from: form.id_tabela_from,
                geral_tabela: form.geral_tabela,
                situacao: form.situacao,
                obrigatorio: form.obrigatorio,
            };
        },
        save() {
            this.isLoading = true;

            this.service.updateObrigatorio(this.assMotivoAtendimentoFormulario)
            .then(value => {
                if (value.content === null) {
                    this.msgs.push(new Message("error", `${value.message}`, true));
                } else {
                    this.$emit('fecharModal', true);
                }
            })
            .catch((e) => {
                this.msgs.push(new Message("alert", 'msg-erro-load', true));
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
        updateValueObrigatorio (item) {
            this.obrigatorioSelected = item;
            this.assMotivoAtendimentoFormulario.obrigatorio = this.obrigatorioSelected.id;
        }
    },
}
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px 60px 20px;
}
</style>
